var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_304_16461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.58214 15.75H0.264286V5.23477H3.58214V15.75ZM1.92143 3.80039C0.860714 3.80039 0 2.93555 0 1.89141C0 1.38867 0.203571 0.910547 0.564286 0.555469C0.925 0.200391 1.41429 0 1.92143 0C2.42857 0 2.91786 0.200391 3.27857 0.555469C3.63929 0.910547 3.84286 1.39219 3.84286 1.89141C3.84286 2.93555 2.98214 3.80039 1.92143 3.80039ZM15.9964 15.75H12.6857V10.6312C12.6857 9.41133 12.6607 7.84687 10.9607 7.84687C9.23571 7.84687 8.97143 9.17227 8.97143 10.5434V15.75H5.65714V5.23477H8.83929V6.66914H8.88571C9.32857 5.84297 10.4107 4.97109 12.025 4.97109C15.3821 4.97109 16 7.14727 16 9.97383V15.75H15.9964Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_16461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinShare);
export default __webpack_public_path__ + "static/media/linkedin_share.e0db702b633f7215599c2adb76a37fd3.svg";
export { ForwardRef as ReactComponent };